module.exports = __webpack_public_path__ + "img/Span-11.e6dd275a.jpg";